import { useEffect } from 'react';
import { backButton } from '@tma.js/sdk-react';

interface TgBackButtonProps {
  onClick: () => void;
}

/**
 * Компонент для управления нативной кнопкой "Назад" в Telegram.
 * Показывает кнопку при монтировании и вызывает onClick при нажатии.
 */
export const TgBackButton: React.FC<TgBackButtonProps> = ({ onClick }) => {
  useEffect(() => {
    // Безопасно проверяем доступность через signals
    const canShow = backButton.show.isAvailable();
    
    if (canShow) {
      backButton.show();
      const off = backButton.onClick(onClick);
      
      return () => {
        off();
        if (backButton.hide.isAvailable()) {
          backButton.hide();
        }
      };
    }
  }, [onClick]);

  return null; // Компонент не рендерит ничего в DOM
};
